import { NgModule } from '@angular/core';
import { EditModeDirective } from './edit-mode.directive';
import { EditableOnEnterDirective } from './edit-on-enter.directive';
import { EditableComponent } from './editable.component';
import { ViewModeDirective } from './view-mode.directive';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    EditModeDirective,
    EditableOnEnterDirective,
    EditableComponent,
    ViewModeDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    EditModeDirective,
    EditableOnEnterDirective,
    EditableComponent,
    ViewModeDirective,
  ],
})
export class EditableModule {
}
